import PICKUPS from "../consts/PICKUPS";
import PickupType from "../enums/PickupType";
import Game from "./Game";

interface WeightedItem {
  weight: number;
  itemType: PickupType;
}

class WeightedLootItem implements WeightedItem {
  weight: number;
  itemType: PickupType;

  constructor(itemType: PickupType, weight: number) {
    this.itemType = itemType;
    this.weight = weight;
  }
}

export default class LootManager {
  private accumulatedWeight: number = 0;
  private weightedStore: WeightedItem[] = [];

  Init() {
    this.calculateWeights();
  }

  private calculateWeights() {
    this.accumulatedWeight = 0;
    this.weightedStore = [];

    for (const key in PICKUPS) {
      const item = PICKUPS[key];
      if (item && Game.Core.Player.level >= item.unlocksAt) {
        if (item.isRare) {
          this.accumulatedWeight += item.rarity * Game.Core.Player.luck;
        } else {
          this.accumulatedWeight += item.rarity;
        }
        if (item.rarity > 0) {
          this.weightedStore.push(
            new WeightedLootItem(key as PickupType, this.accumulatedWeight)
          );
        }
      }
    }
  }

  RecalculateLoot() {
    this.calculateWeights();
  }

  GetRandomWeightedItem(): PickupType | undefined {
    const randomWeight = Math.random() * this.accumulatedWeight;

    for (const item of this.weightedStore) {
      if (item.weight >= randomWeight) {
        return item.itemType;
      }
    }
  }
}
